import { OPERATION_TYPE_LABELS as GL_OPERATION_TYPE_LABELS } from "../GeneralLedger/glUtils";

export const PERMISSIONS = {
  VIEW: "expenses.view",
  CREATE: "expenses.create",
  EDIT: "expenses.edit",
  UPLOAD: "expenses.upload",
  APPROVE: "expenses.approve",
  PAY: "expenses.pay",
  POST: "expenses.post",
  MANAGE_CATEGORIES: "expenses.manage_categories",
  REPORTS: "expenses.reports",
  DELETE: "expenses.delete",
};

export const can = (meta, permission) => Boolean(meta?.permissions?.[permission]);

export const OPERATION_TYPE_LABELS = GL_OPERATION_TYPE_LABELS;

export const STATUS_META = {
  draft: { label: "Draft", color: "secondary" },
  pending_approval: { label: "Pending approval", color: "warning" },
  approved: { label: "Approved", color: "info" },
  rejected: { label: "Rejected", color: "danger" },
  cancelled: { label: "Cancelled", color: "dark" },
  paid: { label: "Paid", color: "success" },
};

export const PAYMENT_STATUS_META = {
  unpaid: { label: "Unpaid", color: "danger" },
  partially_paid: { label: "Partially paid", color: "warning" },
  paid: { label: "Paid", color: "success" },
};

export const ACCOUNTING_STATUS_META = {
  none: { label: "Unposted", color: "secondary" },
  posted: { label: "Posted", color: "success" },
  reversed: { label: "Reversed", color: "dark" },
};

export const FREQUENCY_LABELS = {
  monthly: "Monthly",
  quarterly: "Quarterly",
  annual: "Annual",
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "2026-09-28" -> "28 Sep 2026"; parsed by hand so no timezone shift applies. */
export const formatShortDate = (iso, withYear = true) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || "");
  if (!match) return iso || "—";
  const [, year, month, day] = match;
  const label = `${day} ${MONTHS[Number(month) - 1]}`;
  return withYear ? `${label} ${year}` : label;
};

export const formatMonth = (value) => {
  const match = /^(\d{4})-(\d{2})$/.exec(value || "");
  if (!match) return value || "—";
  return `${MONTHS[Number(match[2]) - 1]} ${match[1]}`;
};

export const statusMeta = (status) => STATUS_META[status] || { label: status || "—", color: "secondary" };
export const paymentStatusMeta = (status) => PAYMENT_STATUS_META[status] || { label: status || "—", color: "secondary" };
export const accountingStatusMeta = (status) => ACCOUNTING_STATUS_META[status] || { label: status || "—", color: "secondary" };
export const operationLabel = (type) => OPERATION_TYPE_LABELS[type] || type || "—";

export const expenseLabel = (expense) => expense?.title || expense?.reference || `#${expense?.id}`;
